import React, { useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getSchool } from '../../actions/schoolsActions'
import { getSubscriptionProducts } from '../../actions/subscriptionProductsActions'



export default function Subscription() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {school, loading: schoolLoading} = useSelector(state=>state.schools)
    const {subscriptionProducts, loading: subscriptionProductsLoading} = useSelector(state=>state.subscriptionProducts)
    console.log(subscriptionProducts);

    useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
            dispatch(getSubscriptionProducts())
        }
    },[dispatch, t, client])

    return (
        <Container className='cuerpo'>
            <Card className='mb-5 sombra'>
                <Card.Body className='px-5 py-5'>
                    {
                        schoolLoading || subscriptionProductsLoading
                        ?
                            <span className="spinner-border"/>
                        :
                            school?.plan
                            ?
                                <></>
                            :
                                <>
                                    <Row className='text-center'>
                                        <h1>339€/año</h1>
                                        <h4>4 procesos/año</h4>
                                    </Row>
                                </>
                    }
                </Card.Body>
            </Card>
        </Container>
    )
}